// extracted by mini-css-extract-plugin
module.exports = {"adminMenu":"AdminNavigation_adminMenu__L7ZZ-","opened":"AdminNavigation_opened__VlaPI","item":"AdminNavigation_item__1Tvfe","inactive":"AdminNavigation_inactive__3utDn"};